// Legal text DE / EN / ES — Impressum & Datenschutz
export const legal = {
  de: {
    company: "Schweizer Planmanufaktur GmbH",
    address_lines: ["Gründenstrasse 82", "8247 Flurlingen", "Schweiz"],
    phone: "+41 52 551 01 40",
    email: "kontakt@schweizer-planmanufaktur.ch",
    ceo: "Thomas Hassoun",
    register_authority: "Handelsregisteramt Zürich",
    uid: "CHE-234.928.102",
    vat: "CHE-234.928.102 MWST",

    impressum: {
      title: "Impressum",
      back: "Zurück zur Startseite",
      sections: [
        {
          h: "Verantwortlich für den Inhalt",
          body: [
            "Schweizer Planmanufaktur GmbH",
            "Gründenstrasse 82",
            "8247 Flurlingen",
            "Schweiz",
          ],
        },
        {
          h: "Kontakt",
          body: [
            "Telefon: +41 52 551 01 40",
            "E-Mail: kontakt@schweizer-planmanufaktur.ch",
          ],
        },
        {
          h: "Vertretungsberechtigte Person",
          body: ["Thomas Hassoun · Geschäftsführer"],
        },
        {
          h: "Handelsregister",
          body: [
            "Eingetragen im Handelsregister des Kantons Zürich",
            "Handelsregisteramt Zürich",
            "Unternehmens-Identifikationsnummer (UID): CHE-234.928.102",
          ],
        },
        {
          h: "Mehrwertsteuer",
          body: ["MWST-Nummer: CHE-234.928.102 MWST"],
        },
        {
          h: "Haftungsausschluss",
          body: [
            "Die Schweizer Planmanufaktur GmbH übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen auf dieser Webseite.",
            "Haftungsansprüche gegen die Schweizer Planmanufaktur GmbH wegen Schäden materieller oder immaterieller Art, welche aus dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten Informationen entstanden sind, werden ausgeschlossen.",
            "Alle Angebote sind unverbindlich. Die Schweizer Planmanufaktur GmbH behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen oder zu löschen.",
          ],
        },
        {
          h: "Haftung für Links",
          body: [
            "Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres Verantwortungsbereichs. Es wird jegliche Verantwortung für solche Webseiten abgelehnt. Der Zugriff und die Nutzung solcher Webseiten erfolgen auf eigene Gefahr des jeweiligen Nutzers.",
          ],
        },
        {
          h: "Urheberrechte",
          body: [
            "Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen Dateien auf dieser Webseite gehören ausschliesslich der Schweizer Planmanufaktur GmbH oder den speziell genannten Rechtsinhabern.",
            "Für die Reproduktion jeglicher Elemente ist die schriftliche Zustimmung der Urheberrechtsträger im Voraus einzuholen.",
          ],
        },
      ],
    },

    datenschutz: {
      title: "Datenschutzerklärung",
      back: "Zurück zur Startseite",
      intro:
        "Wir nehmen den Schutz Ihrer persönlichen Daten ernst und behandeln Ihre personenbezogenen Daten vertraulich und entsprechend dem Schweizer Datenschutzgesetz (revDSG) sowie — soweit anwendbar — der EU-Datenschutz-Grundverordnung (DSGVO).",
      last_update: "Stand: Dezember 2025",
      sections: [
        {
          h: "1. Verantwortlicher",
          body: [
            "Verantwortlich für die Bearbeitung personenbezogener Daten ist:",
            "Schweizer Planmanufaktur GmbH",
            "Thomas Hassoun (Geschäftsführer)",
            "Gründenstrasse 82, 8247 Flurlingen, Schweiz",
            "E-Mail: kontakt@schweizer-planmanufaktur.ch",
            "Telefon: +41 52 551 01 40",
          ],
        },
        {
          h: "2. Erhebung und Bearbeitung personenbezogener Daten",
          body: [
            "Wenn Sie unser Kontaktformular nutzen, werden folgende Daten verarbeitet: Name, E-Mail-Adresse, Telefonnummer (optional), Firma (optional), Einsatzart, Nachricht und die gewählte Sprache.",
            "Die Verarbeitung erfolgt zum Zweck der Bearbeitung Ihrer Anfrage und für die nachfolgende Kommunikation. Rechtsgrundlage ist Ihre Einwilligung durch das Absenden des Formulars (Art. 6 revDSG bzw. Art. 6 Abs. 1 lit. a DSGVO) sowie die Erfüllung vorvertraglicher Massnahmen.",
          ],
        },
        {
          h: "3. Empfänger und Weitergabe",
          body: [
            "Die im Kontaktformular eingegebenen Daten werden per E-Mail an unseren Mitarbeiter Thomas Hassoun (kontakt@schweizer-planmanufaktur.ch) weitergeleitet und zusätzlich in unserer internen Datenbank gespeichert.",
            "Eine Weitergabe an Dritte erfolgt nur, soweit dies zur Erfüllung Ihrer Anfrage erforderlich ist oder wir gesetzlich dazu verpflichtet sind.",
          ],
        },
        {
          h: "4. Hosting und Datenübermittlung",
          body: [
            "Diese Webseite wird auf einem Server der Contabo GmbH in Deutschland gehostet (Auftragsverarbeitung gemäss DSGVO).",
            "Die E-Mail-Zustellung erfolgt über den Schweizer Anbieter Hostpoint AG (Rapperswil-Jona, Schweiz).",
          ],
        },
        {
          h: "5. Speicherdauer",
          body: [
            "Personenbezogene Daten aus Kontaktanfragen werden nur so lange aufbewahrt, wie dies für die Bearbeitung der Anfrage oder zur Erfüllung gesetzlicher Aufbewahrungspflichten (in der Regel max. 10 Jahre nach Schweizer Obligationenrecht) erforderlich ist.",
          ],
        },
        {
          h: "6. Cookies und Tracking",
          body: [
            "Diese Webseite verwendet keine Tracking-Cookies, kein Web-Analytics-Tool (kein Google Analytics o.ä.) und keine Marketing-Pixel.",
            "Die Spracheinstellung wird lokal im Browser (localStorage) gespeichert, um Ihre Wahl bei späteren Besuchen wiederherzustellen. Diese Information verlässt Ihr Gerät nicht.",
          ],
        },
        {
          h: "7. Ihre Rechte",
          body: [
            "Sie haben das Recht auf Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten, auf Berichtigung unrichtiger Daten, auf Löschung sowie auf Einschränkung der Bearbeitung. Zudem können Sie der Bearbeitung widersprechen.",
            "Für die Ausübung Ihrer Rechte wenden Sie sich bitte per E-Mail an kontakt@schweizer-planmanufaktur.ch.",
            "Sie haben zudem das Recht, sich beim Eidgenössischen Datenschutz- und Öffentlichkeitsbeauftragten (EDÖB) bzw. der für Sie zuständigen EU-Datenschutzaufsichtsbehörde zu beschweren.",
          ],
        },
        {
          h: "8. Datensicherheit",
          body: [
            "Wir treffen angemessene technische und organisatorische Massnahmen zum Schutz Ihrer Daten gegen unberechtigten Zugriff, Verlust und Manipulation. Die Übertragung erfolgt verschlüsselt über HTTPS (TLS).",
          ],
        },
        {
          h: "9. Änderungen",
          body: [
            "Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht.",
          ],
        },
      ],
    },
  },

  en: {
    company: "Schweizer Planmanufaktur GmbH",
    address_lines: ["Gründenstrasse 82", "8247 Flurlingen", "Switzerland"],
    phone: "+41 52 551 01 40",
    email: "kontakt@schweizer-planmanufaktur.ch",
    ceo: "Thomas Hassoun",
    register_authority: "Commercial Register Office of Zurich",
    uid: "CHE-234.928.102",
    vat: "CHE-234.928.102 MWST",

    impressum: {
      title: "Imprint",
      back: "Back to home",
      sections: [
        {
          h: "Responsible for content",
          body: [
            "Schweizer Planmanufaktur GmbH",
            "Gründenstrasse 82",
            "8247 Flurlingen",
            "Switzerland",
          ],
        },
        {
          h: "Contact",
          body: [
            "Phone: +41 52 551 01 40",
            "Email: kontakt@schweizer-planmanufaktur.ch",
          ],
        },
        {
          h: "Authorised representative",
          body: ["Thomas Hassoun · Managing Director"],
        },
        {
          h: "Commercial register",
          body: [
            "Registered with the Commercial Register Office of Zurich, Switzerland",
            "Swiss Business Identification Number (UID): CHE-234.928.102",
          ],
        },
        {
          h: "VAT",
          body: ["VAT registration: CHE-234.928.102 MWST"],
        },
        {
          h: "Disclaimer",
          body: [
            "Schweizer Planmanufaktur GmbH makes no warranty as to the accuracy, completeness or timeliness of the information published on this website.",
            "Liability claims against Schweizer Planmanufaktur GmbH for material or immaterial damages resulting from access to, use of or inability to use the published information are excluded.",
            "All offers are non-binding. Schweizer Planmanufaktur GmbH expressly reserves the right to alter, supplement or delete parts of the pages or the entire offering without separate notice.",
          ],
        },
        {
          h: "Links",
          body: [
            "References and links to third-party websites are outside our area of responsibility. Any responsibility for such websites is rejected. Access to and use of such websites is at the user's own risk.",
          ],
        },
        {
          h: "Copyright",
          body: [
            "Copyright and all other rights to content, images, photos and other files on this website are exclusively held by Schweizer Planmanufaktur GmbH or the specifically named rights holders.",
            "Written consent from the rights holders must be obtained in advance for the reproduction of any element.",
          ],
        },
      ],
    },

    datenschutz: {
      title: "Privacy policy",
      back: "Back to home",
      intro:
        "We take the protection of your personal data seriously and treat it confidentially in accordance with the Swiss Data Protection Act (revDSG) and — where applicable — the EU General Data Protection Regulation (GDPR).",
      last_update: "Last updated: December 2025",
      sections: [
        {
          h: "1. Data controller",
          body: [
            "Responsible for processing personal data is:",
            "Schweizer Planmanufaktur GmbH",
            "Thomas Hassoun (Managing Director)",
            "Gründenstrasse 82, 8247 Flurlingen, Switzerland",
            "Email: kontakt@schweizer-planmanufaktur.ch",
            "Phone: +41 52 551 01 40",
          ],
        },
        {
          h: "2. Data collected via the contact form",
          body: [
            "When you use our contact form, the following data is processed: name, email address, phone number (optional), company (optional), engagement type, message and the selected language.",
            "Processing is carried out for the purpose of handling your enquiry and subsequent communication. The legal basis is your consent given by submitting the form and the performance of pre-contractual measures.",
          ],
        },
        {
          h: "3. Recipients and disclosure",
          body: [
            "The data entered in the contact form is forwarded by email to our employee Thomas Hassoun (kontakt@schweizer-planmanufaktur.ch) and additionally stored in our internal database.",
            "Disclosure to third parties only takes place if necessary to handle your enquiry or if we are legally required to do so.",
          ],
        },
        {
          h: "4. Hosting and data transfer",
          body: [
            "This website is hosted on a server of Contabo GmbH in Germany (commissioned data processing under GDPR).",
            "Email delivery is provided by the Swiss provider Hostpoint AG (Rapperswil-Jona, Switzerland).",
          ],
        },
        {
          h: "5. Retention period",
          body: [
            "Personal data from contact enquiries is retained only as long as necessary for processing the request or to fulfil statutory retention obligations (generally up to 10 years under Swiss commercial law).",
          ],
        },
        {
          h: "6. Cookies and tracking",
          body: [
            "This website does not use tracking cookies, web analytics tools (no Google Analytics or similar) or marketing pixels.",
            "The selected language is stored locally in your browser (localStorage) to restore your preference on subsequent visits. This information does not leave your device.",
          ],
        },
        {
          h: "7. Your rights",
          body: [
            "You have the right to access the personal data we hold about you, to rectify inaccurate data, to erase it and to restrict processing. You may also object to processing.",
            "To exercise your rights, please contact kontakt@schweizer-planmanufaktur.ch.",
            "You also have the right to lodge a complaint with the Swiss Federal Data Protection and Information Commissioner (FDPIC) or your competent EU data protection authority.",
          ],
        },
        {
          h: "8. Data security",
          body: [
            "We apply appropriate technical and organisational measures to protect your data against unauthorised access, loss or manipulation. Transmission is encrypted via HTTPS (TLS).",
          ],
        },
        {
          h: "9. Changes",
          body: [
            "We reserve the right to adapt this privacy policy to ensure it always meets current legal requirements.",
          ],
        },
      ],
    },
  },

  es: {
    company: "Schweizer Planmanufaktur GmbH",
    address_lines: ["Gründenstrasse 82", "8247 Flurlingen", "Suiza"],
    phone: "+41 52 551 01 40",
    email: "kontakt@schweizer-planmanufaktur.ch",
    ceo: "Thomas Hassoun",
    register_authority: "Registro Mercantil de Zúrich",
    uid: "CHE-234.928.102",
    vat: "CHE-234.928.102 MWST",

    impressum: {
      title: "Aviso legal",
      back: "Volver a inicio",
      sections: [
        {
          h: "Responsable del contenido",
          body: [
            "Schweizer Planmanufaktur GmbH",
            "Gründenstrasse 82",
            "8247 Flurlingen",
            "Suiza",
          ],
        },
        {
          h: "Contacto",
          body: [
            "Teléfono: +41 52 551 01 40",
            "Correo: kontakt@schweizer-planmanufaktur.ch",
          ],
        },
        {
          h: "Representante autorizado",
          body: ["Thomas Hassoun · Gerente"],
        },
        {
          h: "Registro mercantil",
          body: [
            "Inscrita en el Registro Mercantil del cantón de Zúrich, Suiza",
            "Número de identificación empresarial suizo (UID): CHE-234.928.102",
          ],
        },
        {
          h: "IVA",
          body: ["Número de IVA: CHE-234.928.102 MWST"],
        },
        {
          h: "Exención de responsabilidad",
          body: [
            "Schweizer Planmanufaktur GmbH no garantiza la exactitud, integridad ni actualidad de la información publicada en este sitio web.",
            "Se excluyen las reclamaciones de responsabilidad contra Schweizer Planmanufaktur GmbH por daños materiales o inmateriales derivados del acceso, uso o imposibilidad de uso de la información publicada.",
            "Todas las ofertas son sin compromiso. Schweizer Planmanufaktur GmbH se reserva expresamente el derecho de modificar, complementar o eliminar partes de las páginas o el sitio completo sin previo aviso.",
          ],
        },
        {
          h: "Enlaces",
          body: [
            "Las referencias y enlaces a sitios web de terceros están fuera de nuestro ámbito de responsabilidad. Se rechaza toda responsabilidad por dichos sitios. El acceso y uso son por cuenta y riesgo del usuario.",
          ],
        },
        {
          h: "Derechos de autor",
          body: [
            "Los derechos de autor y demás derechos sobre los contenidos, imágenes, fotos y otros archivos de este sitio pertenecen exclusivamente a Schweizer Planmanufaktur GmbH o a los titulares específicamente nombrados.",
            "Para la reproducción de cualquier elemento se requiere el consentimiento previo por escrito de los titulares.",
          ],
        },
      ],
    },

    datenschutz: {
      title: "Política de privacidad",
      back: "Volver a inicio",
      intro:
        "Nos tomamos en serio la protección de sus datos personales y los tratamos confidencialmente conforme a la Ley Suiza de Protección de Datos (revDSG) y — cuando corresponda — al Reglamento General de Protección de Datos de la UE (RGPD).",
      last_update: "Última actualización: diciembre 2025",
      sections: [
        {
          h: "1. Responsable del tratamiento",
          body: [
            "El responsable del tratamiento de datos personales es:",
            "Schweizer Planmanufaktur GmbH",
            "Thomas Hassoun (Gerente)",
            "Gründenstrasse 82, 8247 Flurlingen, Suiza",
            "Correo: kontakt@schweizer-planmanufaktur.ch",
            "Teléfono: +41 52 551 01 40",
          ],
        },
        {
          h: "2. Datos recogidos por el formulario de contacto",
          body: [
            "Cuando utiliza nuestro formulario de contacto se procesan los siguientes datos: nombre, dirección de correo electrónico, teléfono (opcional), empresa (opcional), tipo de servicio, mensaje e idioma seleccionado.",
            "El tratamiento se realiza con el fin de gestionar su consulta y la comunicación posterior. La base jurídica es su consentimiento al enviar el formulario y la ejecución de medidas precontractuales.",
          ],
        },
        {
          h: "3. Destinatarios y divulgación",
          body: [
            "Los datos introducidos se reenvían por correo a nuestro empleado Thomas Hassoun (kontakt@schweizer-planmanufaktur.ch) y se almacenan adicionalmente en nuestra base de datos interna.",
            "Solo se divulgarán a terceros si es necesario para tramitar su consulta o si la ley nos obliga a ello.",
          ],
        },
        {
          h: "4. Alojamiento y transferencia de datos",
          body: [
            "Este sitio está alojado en un servidor de Contabo GmbH en Alemania (encargo de tratamiento conforme al RGPD).",
            "El envío de correo se realiza a través del proveedor suizo Hostpoint AG (Rapperswil-Jona, Suiza).",
          ],
        },
        {
          h: "5. Plazo de conservación",
          body: [
            "Los datos personales procedentes de consultas se conservan únicamente el tiempo necesario para tramitar la solicitud o para cumplir las obligaciones legales de conservación (generalmente hasta 10 años según el derecho comercial suizo).",
          ],
        },
        {
          h: "6. Cookies y seguimiento",
          body: [
            "Este sitio no utiliza cookies de seguimiento, herramientas de analítica web (sin Google Analytics ni similares) ni píxeles de marketing.",
            "El idioma seleccionado se guarda localmente en su navegador (localStorage) para recuperar su preferencia en visitas posteriores. Esta información no abandona su dispositivo.",
          ],
        },
        {
          h: "7. Sus derechos",
          body: [
            "Tiene derecho a acceder a los datos personales que conservamos, a rectificarlos, a suprimirlos y a limitar su tratamiento. También puede oponerse al tratamiento.",
            "Para ejercer sus derechos, contacte con kontakt@schweizer-planmanufaktur.ch.",
            "Asimismo tiene derecho a presentar una reclamación ante el Comisionado Federal Suizo de Protección de Datos (FDPIC) o ante la autoridad de control competente de la UE.",
          ],
        },
        {
          h: "8. Seguridad de los datos",
          body: [
            "Aplicamos medidas técnicas y organizativas adecuadas para proteger sus datos contra el acceso no autorizado, la pérdida y la manipulación. La transmisión está cifrada mediante HTTPS (TLS).",
          ],
        },
        {
          h: "9. Cambios",
          body: [
            "Nos reservamos el derecho a adaptar esta política de privacidad para que siempre cumpla los requisitos legales vigentes.",
          ],
        },
      ],
    },
  },
};
